export const BUILD_VERSION = '0ba60f00338894e2d609d57250a5a455274d5439';
